<form [formGroup]="form" (ngSubmit)="submit()" class="requisites">
  <h3 class="requisites__title" *ngIf="!hideChrome">Реквизиты компании</h3>

  <div class="requisites__row">
    <label>Название компании</label>
    <input type="text" formControlName="rCompanyName" placeholder="Впишите название юр. лица">
  </div>

  <div class="requisites__row">
    <label>ИНН</label>
    <input type="text" formControlName="rInn" placeholder="10 или 12 цифр">
  </div>

  <button type="submit" class="button button_theme-1" [disabled]="form.invalid" *ngIf="!hideChrome">
    Сохранить и выставить счёт
  </button>
</form>
